<template>

  <v-card max-width="900px">
    <v-card-title >
      Upper GI Endoscopy
    </v-card-title>
    <v-card-text  class="content-text">

      <div class="title">
        What Is It?
      </div>
      <img src="@/assets/images/content/endoscopy.png"  class="image floated-image">
      <p>
        An  upper GI endoscopy, or EGD (short for esophagogastroduodenoscopy), is  a visual inspection of the upper GI tract
        (your esophagus, stomach, and duodenum or first part of your small intestine) using an endoscope
        which is just a special  tube with a high resolution camera that's connected to a
        video monitor and a set of controls that allow your doctor to navigate your esophagus and stomach
        (See diagram)
      </p>


      <div class="title">
        Why Is It Performed?
      </div>
      <p>
        EGD's are most commonly used by doctors to diagnostic tool to discover why you might be experiencing
        one or more of the following:
      </p>
      <ul>
        <li>Abdominal pain</li>
        <li>Bloody stool</li>
        <li>Heartburn</li>
        <li>Persistent nausea or vomiting</li>
        <li>Swallowing difficulties</li>
        <li>Upper gastrointestinal bleeding</li>
      </ul>

      <p class="pt-3">
        EGD's may also be used to remove foreign objects, take biopsies, and/or remove polyps (growths on the lining of the stomach).
      </p>


      <div class="title">
        What To Expect
      </div>
      <p>
        An EGD is an out-patient procedure performed on location at our Endoscopy Center.  The procedure itself
        usually takes about 15 - 20 minutes.  The entire experience, including prep and recovery, on average takes
        about 2 hours.


        EGD's are typically performed under intravenous sedation (you'll be unconscious during the procedure)
        to minimize your discomfort.
      </p>
      <p>
        After an EGD, you may experience a sore throat and mild abdominal bloating.  After
        the recovery period, you'll be sent home and  can return to normal activity including eating.  However,
        as with any sedation, reasonable care should be taken before resuming normal activities.  In particular,
        you SHOULD NOT drive yourself home after the procedure.
      </p>



      <div class="title">
        Preparation
      </div>
      <p>
        Prior to an EGD, you will receive an instruction packet specific to you.  In general though
      </p>
      <ul>
        <li>No food or liquids (this includes water) minimally 6 hours prior to the procedure.</li>
        <li>Plan to take the day off from work for the exam.</li>
        <li>Plan to have someone you know drive you home. Since the procedure is usually performed with
          intravenous sedation, you should not drive a car or return to work until the next day.</li>
      </ul>
    </v-card-text>

  </v-card>



</template>






<style scoped lang="scss">

  @use 'contentStyles';




</style>


<script>
// @ is an alias to /src


export default {
   data(){return {


   }},



}
</script>
